import React from 'react';
import type { Aktivitet } from '@klp/formgenerator/interfaces';

import { useCurrentUser } from '@klp/auth';
import { useFormattedDate } from '@klp/contractregistration/utils';
import { Typography } from '@klp/design/Typography';
import {
    FormContainerLeverandor,
    FormAlert,
    FormContextProvider,
} from '@klp/formgenerator';
import { useAssignResponsibleUser } from '../TildelAnsvarlig/hooks/useAssignResponsibleUser';
import { useFormAuth } from '@klp/formgenerator/hooks';
import type { LEVERANDOR_REGIONS } from '@klp/leverandor/types';

type LeverandorFormProps = {
    prosessInstansId: string;
    activity: Aktivitet;
    superofficeId: string;
    orgnummer: string;
    registreringStatus?: string;
    prosessRegion: LEVERANDOR_REGIONS;
};

export const LeverandorForm: React.FC<LeverandorFormProps> = ({
    prosessInstansId,
    activity,
    superofficeId,
    orgnummer,
    registreringStatus,
    prosessRegion,
}) => {
    const { currentUser } = useCurrentUser();
    const formattedActivityDate = useFormattedDate(activity.utfortDato);
    const { handleAssignResponsibleUser, assigningTask } =
        useAssignResponsibleUser(superofficeId, prosessInstansId, activity);
    const { isActivityEditable } = useFormAuth();

    const isDisabled = !isActivityEditable(activity);

    return (
        <>
            <FormAlert
                activity={activity}
                currentUser={currentUser}
                handleAssignResponsibleUser={(email) =>
                    handleAssignResponsibleUser(email, undefined, undefined)
                }
                assigningTask={assigningTask}
                registreringStatus={registreringStatus}
            />
            <FormContextProvider initialRegion={prosessRegion}>
                <FormContainerLeverandor
                    prosessInstansId={prosessInstansId}
                    activity={activity}
                    formFields={activity.formFields}
                    isDisabled={isDisabled}
                    superofficeId={superofficeId}
                    orgnummer={orgnummer}
                />
            </FormContextProvider>

            {activity.utfortDato && (
                <Typography
                    paddingTop="compact"
                    translation="leverandor.completedBy"
                    translationOptions={{
                        name: activity.tildeltTil,
                        date: formattedActivityDate,
                    }}
                />
            )}
        </>
    );
};
